import _toConsumableArray from "/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.promise.finally.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { startTask } from '../task/index.js';
export var lastAction = Symbol();
var doAction = function doAction(store, actionName, cb, args) {
  var tracker = _objectSpread({}, store);
  tracker.set = function () {
    store[lastAction] = actionName;
    store.set.apply(store, arguments);
    delete store[lastAction];
  };
  if (store.setKey) {
    tracker.setKey = function () {
      store[lastAction] = actionName;
      store.setKey.apply(store, arguments);
      delete store[lastAction];
    };
  }
  var result = cb.apply(void 0, [tracker].concat(_toConsumableArray(args)));
  if (result instanceof Promise) {
    var endTask = startTask();
    return result.finally(endTask);
  }
  return result;
};
export var action = function action(store, actionName, cb) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return doAction(store, actionName, cb, args);
  };
};
export var actionFor = function actionFor(Template, actionName, cb) {
  return function (store) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    return doAction(store, actionName, cb, rest);
  };
};